import { compose, hoistStatics, withState, withHandlers, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import EmptyCovers from './EmptyCovers';
import ModelService from '../../../../services/settings.service';

const onClick = props => async () => {
  props.setIsUpdating(true);
  await ModelService.emptyCoversDirectory();
  props.setIsUpdating(false);
};

const defaultIcon = 'fa fa-folder-open mr-1';
const updatingIcon = 'fa fa-refresh fa-spin mr-1';

const enhance = compose(
  withState('isUpdating', 'setIsUpdating', false),
  translate('core'),
  withProps(props => ({
    icon: props.isUpdating ? updatingIcon : defaultIcon,
  })),
  withHandlers({
    onClick,
  }),
);

export default withRouter(hoistStatics(enhance)(EmptyCovers));



// WEBPACK FOOTER //
// ./src/views/settings/components/emptyCovers/index.js